
/* eslint-disable no-console */
/* eslint-disable no-undef */
import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './dashboard-plugin'
import Loading from 'vue-loading-overlay'
import Axios from 'axios'
import xhrAdapter from 'axios/lib/adapters/xhr'
import settle from 'axios/lib/core/settle'
import { Select, Option, DatePicker, TimeSelect, Container, Main, Row, Col, Card, Button, Timeline, TimelineItem, Avatar, TabPane, Tabs } from 'element-ui'
import Chat from '@teslontechnologies/vue-beautiful-chat'
import VeeValidate, { Validator } from 'vee-validate'
import i18n from './plugins/i18n.js'
import VueYoutube from 'vue-youtube'
import { Badge, Pagination, Modal, Slider, Radio } from 'src/components'
import { v1 as uuidv1 } from 'uuid'
import swal from 'sweetalert2'
import VueTuicalendar from '@lkmadushan/vue-tuicalendar'
import { StarRating } from "vue-rate-it";
import { Checkbox } from "src/components/index";
import $ from 'jquery'
import fullscreen from 'vue-fullscreen'
import moment from 'moment'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import Notifications from 'src/components/NotificationPlugin/index'
import { CoolSelect } from "vue-cool-select";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import 'vue2-animate/dist/vue2-animate.min.css';
import avatarImage from "src/assets/img/proAvatar.png";
import socket from "@/services/socket";
import { DoctorDetails, CheckMarkSvg, ProfileImage, DoctorDetailsCard, SlotSelection, AppointmetDetailsCard } from 'src/pages/carenation/components'
import Prescription from "src/pages/carenation/components/Prescription.vue";
import vueSignature from "vue-signature";
import DynamicImage from "src/pages/carenation/components/DynamicImage.vue";
import DynamicImageBackground from "src/pages/carenation/components/DynamicImageBackground.vue";
import DynamicVideo from "src/pages/carenation/components/DynamicVideo.vue";
import Vmaatu from "./pages/simplemeetings/Vmaatu.vue";
import WebexTeams from "./pages/simplemeetings/WebexTeams.vue";
import OtpModal from "./pages/carenation/components/OtpModal.vue";
import PatientCard from "./pages/carenation/components/PatientCard";
import PinchZoom from 'vue-pinch-zoom';
import 'vue-loading-overlay/dist/vue-loading.css'
import 'tui-calendar/dist/tui-calendar.min.css'
import 'tui-date-picker/dist/tui-date-picker.min.css'
import 'tui-time-picker/dist/tui-time-picker.min.css'
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
import InfiniteLoading from 'vue-infinite-loading';
import DoctorCard from "@/pages/carenation/components/DoctorCard";
import MyDoctorCard from "@/pages/carenation/components/MyDoctorCard";
// Plugins
import App from './App.vue'

// router setup
import routes from './routes/routes'

//Store
import store from './store/store.js'

//remote control
import "./plugins/fontawesome"
import Vue2TouchEvents from "vue2-touch-events"

import { Carousel, Slide } from "vue-carousel";


let pdfMake = require("pdfmake/build/pdfmake.js");
let pdfFonts = require("pdfmake/build/vfs_fonts.js");
import fonts from "@/assets/fonts/pdfmake-font.json";

import DeviceDetector from "device-detector-js";
const deviceDetector = new DeviceDetector();

Vue.use(Vue2TouchEvents)

window.swal = swal.mixin({
  reverseButtons: true
})
window.$ = $
window.moment = moment
window.socket = socket
window.pdfMake = pdfMake
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = fonts;

Vue.component(Badge.name, Badge)
Vue.component(Pagination.name, Pagination)
Vue.component(Radio.name, Radio)
Vue.component('star-rating', StarRating)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Modal.name, Modal)
Vue.component(Slider.name, Slider)
Vue.component('cool-select', CoolSelect)
Vue.component("VuePhoneNumberInput", VuePhoneNumberInput)
Vue.component('doctor-details', DoctorDetails)
Vue.component('check-mark-svg', CheckMarkSvg)
Vue.component('profile-image', ProfileImage)
Vue.component('doctor-details-card', DoctorDetailsCard)
Vue.component('loading', Loading)
Vue.component('slot-selection', SlotSelection)
Vue.component('appointment-details-card', AppointmetDetailsCard)
Vue.component('prescription', Prescription)
Vue.component('vue-signature', vueSignature)
Vue.component('dynamic-image', DynamicImage)
Vue.component('dynamic-image-background', DynamicImageBackground)
Vue.component('dynamic-video', DynamicVideo)
Vue.component('vmaatu', Vmaatu);
Vue.component('webex-teams', WebexTeams);
Vue.component('otp-modal', OtpModal)
Vue.component('patient-card', PatientCard)
Vue.component('pinch-zoom', PinchZoom);
Vue.component('vue-google-autocomplete', VueGoogleAutocomplete)
Vue.component('vue-datetime', Datetime);
Vue.component('doctor-card', DoctorCard)
Vue.component('my-doctor-card', MyDoctorCard)
Vue.component('carousel', Carousel)
Vue.component('slide', Slide)


// plugin setup
Vue.use(VueRouter)
Vue.use(DashboardPlugin)
Vue.use(store)
Vue.use(Loading)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(Chat)
Vue.use(VeeValidate)
Vue.use(VueYoutube)
Vue.use(Container)
Vue.use(Main)
Vue.use(Row)
Vue.use(Col)
Vue.use(Avatar)
Vue.use(Card)
Vue.use(Button)
Vue.use(VueTuicalendar)
Vue.use(fullscreen)
Vue.use(Notifications)
Vue.use(InfiniteLoading, {});
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(TabPane)
Vue.use(Tabs)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          console.log('saved position', savedPosition)
          resolve(savedPosition)
        }, 500)
      })
    } else {

      return { x: 0, y: 0 }
    }
  }
});

function toast(msg) {
  if (window.plugins.toast) {
    window.plugins.toast.showShortBottom(msg);
  } else {
    alert(msg);
  }
}

function onError(err) {
  if (typeof err == 'object') {
    err = err.message;
  }

  //Not showing toast as the a 'Unknown Error' shows up on install
  //toast(err);
  console.error(err)
}

const AxiosNativeHttpAdapter = config =>
  new Promise((resolve, reject) => {
    if (window.device.platform === 'iOS' && cordova.plugin.http) {
      console.log("cordovaPluginHttpAdapter request", config);
      let requestContentType = (config.headers)['Content-Type'] || (config.headers)['content-type'];
      let requestJson = requestContentType && requestContentType.indexOf('application/json') > -1;
      let requestBinary = requestContentType && (requestContentType.indexOf('application/') > -1 || requestContentType.indexOf('image/') || requestContentType.indexOf('video/')) && !requestJson;
      let data = (config.data && requestJson) ? JSON.parse(config.data) : ((config.data && requestBinary) ? config.data : null)
      let serializer = (config.data && requestJson) ? 'json' : ((config.data && requestBinary) ? 'raw' : undefined)

      let options = {
        method: config.method,
        data: data,
        headers: config.headers,
        serializer: serializer,
        responseType: config.responseType
      };

      config.url = new URL(config.url).href
      cordova.plugin.http.sendRequest(config.url, options, function (response) {
        // console.log("cordovaPluginHttpAdapter response", response);
        response.config = {};
        let responseContentType = (response.headers)['Content-Type'] || (response.headers)['content-type'];
        let responseJson = responseContentType && responseContentType.indexOf('application/json') > -1;
        if (response.data && responseJson) {
          response.data = JSON.parse(response.data);
        }
        settle(resolve, reject, response);
      }, function (response) {

        //Sending as object to keep consistent with android
        reject({ response });
      });
    } else {
      xhrAdapter(config).then(response => {
        settle(resolve, reject, response);
      }).catch(reject);
    }
  });

//temporary fix for input field scrolling below the keyboard
window.visualViewport.addEventListener('resize', () => {
  setTimeout(() => {
    document.activeElement.scrollIntoViewIfNeeded()
  }, 1000);
})

if (typeof cordova === 'undefined') {
  console.log('not cordova')
  initVueApp()
}

document.addEventListener('deviceready', initVueApp)

function initVueApp() {
  console.log("Device ready...");

  //Global mixins
  Vue.mixin({
    data() {
      return {
        avatarImage,

        //v-validate dictionary
        dictionary: null,
        device: deviceDetector.parse(navigator.userAgent)
      }
    },
    mounted() {
      if (this.$i18n) {
        this.dictionary = {
          custom: {
            email: {
              required: this.$t('message.Please enter the email'),
              email: this.$t('message.Please enter a valid Email')
            },
            firstName: {
              required: this.$t('message.Please enter the first name'),
            },
            lastName: {
              required: this.$t('message.Please enter the last name'),
            },
            gender: {
              required: this.$t('message.Please enter the gender'),
            },
            age: {
              required: this.$t('message.Please enter the age'),
            },
            reason: {
              required: this.$t('message.Please enter the reason'),
            },
            creditRequestTransactionId: {
              required: this.$t('message.Transaction ID is required')
            },
            creditRequestAmount: {
              required: this.$t('message.Please enter a valid Amount')
            }
          },
        }

        let locale = this.getLocaleString()
        Validator.localize(locale, this.dictionary);
      }
    },
    methods: {
      _getFormattedDate(date, format, isDateString) {
        if (!format) {
          return date
        }

        let dateToFormat = date

        if (!isDateString) {
          dateToFormat = parseInt(dateToFormat)
        }

        if (format == 'ago') {
          return moment(dateToFormat).locale(this.getLocaleString()).fromNow();
        }
        else {
          return moment(dateToFormat).locale(this.getLocaleString()).format(format);
        }

      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      calendarLanguageObject() {
        let calendarTranslate = {
          titles: {
            // days
            DD: [this.$t('message.Sunday'), this.$t('message.Monday'), this.$t('message.Tuesday'), this.$t('message.Wednesday'), this.$t('message.Thursday'), this.$t('message.Friday'), this.$t('message.Saturday')],
            // daysShort
            D: [this.$t('message.Sun'), this.$t('message.Mon'), this.$t('message.Tue'), this.$t('message.Wed'), this.$t('message.Thu'), this.$t('message.Fri'), this.$t('message.Sat')],
            // months
            MMMM: [
              this.$t('message.January'), this.$t('message.February'), this.$t('message.March'), this.$t('message.April'), this.$t('message.May'), this.$t('message.June'),
              this.$t('message.July'), this.$t('message.August'), this.$t('message.September'), this.$t('message.October'), this.$t('message.November'), this.$t('message.December')
            ],
            // monthsShort
            MMM: [this.$t('message.Jan'), this.$t('message.Feb'), this.$t('message.Mar'), this.$t('message.Apr'), this.$t('message.May'), this.$t('message.Jun'),
            this.$t('message.Jul'), this.$t('message.Aug'), this.$t('message.Sep'), this.$t('message.Oct'), this.$t('message.Nov'), this.$t('message.Dec')]
          },
          titleFormat: 'MMM yyyy',
          todayFormat: 'D, MMMM dd, yyyy',
          date: 'Date',
          time: 'Time'
        };
        return calendarTranslate
      },
      getLocaleName() {
        if (this.$i18n.locale == "en-US") {
          return "English";
        } else if (this.$i18n.locale == "el-GR") {
          return "Ελληνικά";
        } else if (this.$i18n.locale == "es-ES") {
          return "Español";
        } else if (this.$i18n.locale == "kn") {
          return "ಕನ್ನಡ";
        } else if (this.$i18n.locale == "hi") {
          return "हिन्दी";
        } else if (this.$i18n.locale == "ru") {
          return "русский";
        } else if (this.$i18n.locale == "ar") {
          return "عربي";
        } else if (this.$i18n.locale == "fr") {
          return "française";
        }
      },
      getLocaleString() {
        if (this.$i18n.locale == "en-US") {
          return "en";
        } else if (this.$i18n.locale == "el-GR") {
          return "el";
        } else if (this.$i18n.locale == "es-ES") {
          return "es";
        } else if (this.$i18n.locale == "kn") {
          return "kn";
        } else if (this.$i18n.locale == "hi") {
          return "hi";
        }
      },
      getGender(gender) {
        if (gender == 'male') {
          return this.$t('message.Male');
        } else if (gender == 'female') {
          return this.$t('message.Female');
        } else if (gender == 'others') {
          return this.$t('message.Others');
        } else {
          return gender
        }
      },
      getAge(date) {
        var m = moment(date);
        var years = moment().diff(m, "years", false);
        var months = moment().diff(m.add(years, "years"), "months", false);
        return years + " " + this.$t('message.Years') + " " + months + " " + this.$t('message.Months');
      },
      getCurrencyClass(currencyCode) {
        switch (currencyCode) {
          case "INR":
            return "fa fa-rupee-sign";
          case "USD":
            return "fa fa-dollar-sign";
          case "EUR":
            return "fa fa-euro-sign";
          case "JPY":
            return "fa fa-yen-sign";
          case "RUB":
            return "fa fa-ruble-sign";
          case "GBP":
            return "fa fa-pound-sign";
          case "NPR":
            return "fa fa-nepal-rupee-sign";
          default:
            return "fa fa-rupee-sign";
        }
      },
      scrollTo(wrapper, elementId) {
        let element = document.getElementById(wrapper);
        let height = 0;
        if (elementId) {
          let ele = document.getElementById(elementId);
          if (ele && ele.offsetHeight) {
            height = ele.offsetHeight;
          }
        }
        element.scrollTop = element.scrollHeight - height;
      },
      dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(",")[1]);

        // separate out the mime component
        var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        var ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], { type: mimeString });
        return blob;
      },
      goToHome() {
        if (this.user) {
          if (this.user.roles.includes('doctor')) {
            this.$router.push('home')
          } else if (this.user.roles.includes('nurse')) {
            this.$router.push('nursehome')
          }
          else if (this.user.roles.includes('careCoordinator')) {
            this.$router.push('carecohome')
          }
          else if (this.user.roles.includes('lab-operator')) {
            this.$router.push('laboperatorhome')
          }
          else if (this.user.roles.includes('lab-runner')) {
            this.$router.push('labrunnerhome')
          } else if (this.user.roles.includes("patient")) {
            this.$router.push('patienthome');
          } else if (this.user.roles.includes('ambulance-driver')) {
            this.$router.push('ambulancedriverhome')
          }
        } else {
          this.$router.push('/signin')
        }
      },
      setAppHeaderText(text) {
        this.$store.commit("setState", {
          stateName: "appHeaderText",
          stateValue: text,
        });
      },
      changeAppHeaderText(label) {
        let appHeaderText = ""
        switch (label) {
          //common
          case "terms-of-use":
            appHeaderText = "message.Terms of Use";
            break;
          case "privacy-policy":
            appHeaderText = "message.Privacy Policy";
            break;
          case "waiting-room":
            if (this.user.roles.includes('careCoordinator')) {
              appHeaderText = "message.Request Queue";
            } else {
              appHeaderText = "message.Waiting Room";
            }
            break;
          case "quick-discussion":
            appHeaderText = "message.Discussion";
            break;
          case "scheduled-appts":
            appHeaderText = "message.Scheduled Appointments";
            break;
          case "completed-appts":
            appHeaderText = "message.Appointment History";
            break;
          case "patient-history":
            appHeaderText = "message.Patient History";
            break;
          case "file-share":
            appHeaderText = "message.File Share";
            break;
          case "prescription":
            appHeaderText = "message.Prescription"
            break;
          case "chat-messages":
            appHeaderText = "message.Chat Messages";
            break;
          case "patient-management":
            appHeaderText = "message.Patients";
            break;
          case "lab-orders":
            appHeaderText = "message.Lab Orders";
            break;
          case "live-lab-orders":
            appHeaderText = "message.Live Lab Orders";
            break;
          case "new-lab-orders":
            appHeaderText = "message.New lab orders";
            break;
          case "my-lab-orders":
            appHeaderText = "message.My lab orders";
            break;
          case "inprogress-lab-orders":
            appHeaderText = "message.In progress Lab Orders";
            break;
          case "historic-lab-orders":
            appHeaderText = "message.Previous Lab Orders";
            break;
          case "lab-order-details":
            appHeaderText = "message.Lab Order Details";
            break;
          case "lab-reports":
            appHeaderText = "message.Lab Reports";
            break;
          case "scheduled-checkups":
            appHeaderText = "message.Scheduled Checkups";
            break;


          //nurse
          case "nurse-calling":
            appHeaderText = "message.Service Requests";
            break;
          case "schedule-appointment":
            appHeaderText = "message.Schedule an appointment";
            break;

          //doctor
          case "icu-tab":
            appHeaderText = "message.ICU";
            break;
          case "messaging":
            appHeaderText = "message.Messages";
            break;

          //careco
          case "assistant-room":
            appHeaderText = "message.Waiting Room";
            break;
          case "patient-monitoring":
            appHeaderText = "message.Patient Monitoring";
            break;
          case "appointment-details":
            appHeaderText = "message.Appointment Details";
            break;

          //Telemed
          case "chat-message":
            appHeaderText = "message.Chat";
            break;
          case "video-call":
            appHeaderText = "message.Video";
            break;
          case "live-vitals":
            appHeaderText = "message.Live Vitals";
            break;

          //Patient
          case "appointments":
            appHeaderText = "message.Appointments";
            break;
          case "menu":
            appHeaderText = "message.My Health";
            break;

          case "myhealth":
            appHeaderText = "message.My Health";
            break;

          case "myprofile":
            appHeaderText = "message.Profile";
            break;

          case "patienthome":
            appHeaderText = "message.Patient Home";
            break;

          case "feed":
            appHeaderText = "message.Feed";
            break;

          case "forum":
            appHeaderText = "message.Forum";
            break;
          case "create-issue":
            appHeaderText = "message.New Issue";
            break;
          case "Breakfast Recipes":
            appHeaderText = "message.Breakfast Recipes";
            break;
          case "Lunch Recipes":
            appHeaderText = "message.Lunch Recipes";
            break;
          case "Dinner Recipes":
            appHeaderText = "message.Dinner Recipes";
            break;

          //credits
          case "add-credit-points":
            appHeaderText = "message.Credits";
            break;
          case "credit-requests":
            appHeaderText = "message.Credit history";
            break;

          case "book-appointment":
            appHeaderText = "message.Book Appointment";
            break;

          default:
            appHeaderText = label
        }

        this.$store.commit("setState", {
          stateName: "appHeaderText",
          stateValue: appHeaderText,
        });
      },
    },
    computed: {
      baseUrl() {
        return store.state.baseUrl
      },
      user() {
        if (localStorage.user) {
          return JSON.parse(localStorage.user);
        }
      },
      isTouchScreenDevice() {
        if ("ontouchstart" in window) {
          // Touch screen is supported
          return true;
        } else {
          // Touch screen is not supported
          return false;
        }
      },
      OFFLINE() {
        return store.state.OFFLINE
      },
      instance() {
        if (store.state.settings && store.state.settings.instanceDomain) {
          return store.state.settings.instanceDomain.split(":")[0].replace(/\./g, "_");
        } else {
          return store.state.baseUrl
            .split("//")[1]
            .split(":")[0]
            .replace(/\./g, "_");
        }
      },
      settings() {
        return store.state.settings
      },
      // device() {
      //   return device;
      // },
      appSettings() {
        return store.state.appSettings;
      },
      appSettings() {
        return store.state.appSettings;
      },
    },
    watch: {
      settings: function () {

        if (this.settings && this.settings.theming && this.settings.theming.telemed) {
          let colors = this.settings.theming.telemed

          colors.primaryColor && document.documentElement.style.setProperty('--color-primary', colors.primaryColor)
          colors.secondaryColor1 && document.documentElement.style.setProperty('--color-secondary1', colors.secondaryColor1)
          colors.secondaryColor2 && document.documentElement.style.setProperty('--color-secondary2', colors.secondaryColor2)
          colors.secondaryColor3 && document.documentElement.style.setProperty('--color-secondary3', colors.secondaryColor3)
        }
        if (this.settings && this.settings.theming && this.settings.theming.telemed) {
          Loading.components.Spinner.props.color.default = this.settings.theming.telemed.primaryColor
        }

        if (document.getElementById("preloader")) {
          setTimeout(() => {
            document.getElementById("preloader").remove();
          }, 1000)
        }

      },
      '$i18n.locale': function (locale) {

        if (locale == 'ar') {
          document.documentElement.setAttribute('dir', 'rtl')
        }
        else {
          document.documentElement.setAttribute('dir', null)
        }
      }
    }
  });

  if (typeof cordova !== 'undefined') {
    Vue.http = Vue.prototype.$http = Axios.create({
      adapter: AxiosNativeHttpAdapter
    });
  }
  else {
    Vue.http = Vue.prototype.$http = Axios
  }

  // adding request interceptors
  Vue.http.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      if (store.state.locationTracking && store.state.locationTracking == true && config.url && new URL(config.url).hostname == 'api.bigdatacloud.net') {
        config.withCredentials = false;
      } else if (config.withCredentials != false) {
        config.withCredentials = true;
      }

      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  /* eslint-disable no-new */
  let vue = new Vue({
    i18n,
    el: '#app',
    render: h => h(App),
    router,
    store
  })

  if (i18n.locale == 'ar') {
    document.documentElement.setAttribute('dir', 'rtl')
  }

  //Adding a response interceptor
  Vue.http.interceptors.response.use((response) => {
    return response
  }, function (error) {
    if (error.response && error.response.status == 401) {
      localStorage.user = null
      if (error.response.data && error.response.data.message == 'Tenant is disabled') {
        swal.fire({
          title: vue.$t("message.Tenant is disabled"),
          text: vue.$t("message.Please contact administrator"),
          timer: 4000,
          type: "info",
        });
        router.push({ name: "Login" })
      } else {
        router.push({ name: "Login" })
      }
    }
    else {
      return Promise.reject(error)
    }
  })

  if (!localStorage.deviceId) {
    localStorage.setItem('deviceId', uuidv1())
  }

  window.modals = []

  document.addEventListener("backbutton", function () {
    let modalClosed = false;
    //To close modal on back button
    for (let modal of modals) {
      if (modal._props && modal._props.show && modal.closeModal) {
        modal.closeModal()
        modalClosed = true;
      }
    }
    if (!modalClosed) {
      if (swal.isVisible()) {
        swal.close()
      } else if (vue.$root.onBackButton) {
        vue.$root.onBackButton()
      } else {
        vue.$router.back()
      }
    }
  })

  document.addEventListener(
    "resume",
    (event) => {
      try {
        if (window.onAppResume) {
          window.onAppResume()
        }

        if (window.razorpaySuccessCallback && this.$store.state.paymentGateway && RazorpayCheckout) {
          // Re-register the payment success and cancel callbacks
          RazorpayCheckout.on('payment.success', window.razorpaySuccessCallback)
          RazorpayCheckout.on('payment.cancel', window.razorpaySuccessCallback)
          // Pass on the event to RazorpayCheckout
          RazorpayCheckout.onResume(event);
        }

      } catch (e) {
        console.log(e)
      }
    },
    {
      capture: false,
      once: true,
    }
  )
  // Check for permissions
  // eslint-disable-next-line
  if (typeof cordova !== 'undefined') {
    let permissions = cordova.plugins.permissions;
    let requiredPermissions = [];
    if (store.state.connectedDevices) {
      if (Number(device.sdkVersion) <= 30) {
        requiredPermissions = [permissions.CAMERA, permissions.BLUETOOTH, permissions.BLUETOOTH_ADMIN, permissions.ACCESS_COARSE_LOCATION, permissions.ACCESS_FINE_LOCATION, permissions.WRITE_EXTERNAL_STORAGE, permissions.READ_EXTERNAL_STORAGE, permissions.RECORD_AUDIO, permissions.MODIFY_AUDIO_SETTINGS, permissions.ACTIVITY_RECOGNITION, permissions.BODY_SENSORS];
      } else {
        requiredPermissions = [permissions.CAMERA, permissions.BLUETOOTH_SCAN, permissions.BLUETOOTH_CONNECT, permissions.ACCESS_COARSE_LOCATION, permissions.ACCESS_FINE_LOCATION, permissions.WRITE_EXTERNAL_STORAGE, permissions.READ_EXTERNAL_STORAGE, permissions.RECORD_AUDIO, permissions.MODIFY_AUDIO_SETTINGS, permissions.ACTIVITY_RECOGNITION, permissions.BODY_SENSORS];
      }
    } else {
      requiredPermissions = [permissions.WRITE_EXTERNAL_STORAGE, permissions.READ_EXTERNAL_STORAGE, permissions.CAMERA, permissions.RECORD_AUDIO, permissions.MODIFY_AUDIO_SETTINGS];
    }

    permissions.requestPermissions(requiredPermissions, function (status) {
      if (!status.hasPermission) {
        onError({
          error: 'NoPermission',
          message: 'no permission'
        });
      }

      //Request Firebase foreground notifications
      try {
        cordova.plugins.firebase.messaging.requestPermission({ forceShow: true }).then(() => {
          console.log("You'll get foreground notifications when a push message arrives")

          cordova.plugins.firebase.messaging.getToken().then(function (token) {
            console.log("Got device token: ", token)
            localStorage.setItem('firebaseToken', token)
          })
        })
        cordova.plugins.firebase.messaging.createChannel({
          id: "callNotification",
          name: "Custom channel",
          importance: 5,
          sound: "ringtone",
          badge: true
        }).then((data) => {
          console.log(data);
        })

        cordova.plugins.firebase.messaging.createChannel({
          id: "erEncoutnerUpdate",
          name: "ER encounter channel",
          importance: 5,
          sound: "emergencytone",
          badge: true
        }).then((data) => {
          console.log(data);
        })

        cordova.plugins.firebase.messaging.onBackgroundMessage(function (
          payload
        ) {
          console.log("New background FCM message: ", payload);
          store.commit("setState", {
            stateName: "FCMpayload",
            stateValue: payload,
          });
        });
      } catch (e) {
        console.error(e)
      }
    }, onError);

    if (cordova.plugins.notification.local.launchDetails && cordova.plugins.notification.local.launchDetails.action && cordova.plugins.notification.local.launchDetails.action == "click") {
      console.log(cordova.plugins.notification.local.launchDetails);
      store.commit("setState", {
        stateName: "launchedByClickingOnLocalNotification",
        stateValue: cordova.plugins.notification.local.launchDetails,
      });
    }
  }

}

/* We import element-ui variables at the end so they can override the default element-ui colors */
import './assets/sass/element_variables.scss'
